import { useEventCallback } from '@mui/material';
import { Fragment, ReactElement } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { DetailMetricCrubs } from 'practice/constants/metric-crubs';
import FormMetric, { FormMetricVM } from 'practice/components/metric/form';
import { noop } from 'shell/utils/noop';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { metricResponseTransformer } from 'practice/utils/metric-response-transformer';
import { HttpResponse } from 'shell/models/http-response';
import { MetricData } from 'shell/models/type-metric';

const DetailMetric = (): ReactElement => {
  const navigate = useNavigate();

  const params = useParams();

  const [metric] = useHttpFetch<HttpResponse<MetricData>, FormMetricVM>(
    `${__PRACTICE_API_URL__}/pratiche/metrica/${params?.tyRegistro}-${params?.tyPratica}-${params?.tyOperazione}-${params?.codStatoPratica}/${params?.dataAttivazione}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {
          dataDisattivazione: undefined,
          key: {
            tipoRegistro: params?.tyRegistro,
            tipoPratica: params?.tyPratica,
            tipoOperazione: params?.tyOperazione,
            codStatoPratica: params?.codStatoPratica,
            dataAttivazione: undefined,
          },
        },
      },
      transformer: metricResponseTransformer,
    }
  );

  const onCancel = useEventCallback(() => {
    navigate('/pratiche/ricerca-metrica');
  });

  return (
    <Fragment>
      <Breadcrumbs items={DetailMetricCrubs} />
      {metric.isLoading || metric.pristine || metric.hasErrors ? undefined : (
        <FormMetric
          title="Dettaglio Metrica"
          onCancel={onCancel}
          disabled
          initialValues={metric?.data as FormMetricVM}
          onSubmit={noop}
        />
      )}
    </Fragment>
  );
};

DetailMetric.displayName = 'New Metric Page component';

export default DetailMetric;
